/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObtenerAnaliticaModelDto } from '../../models/obtener-analitica-model-dto';

export interface AnaliticasControllerObtenerAnalitica$Params {

/**
 * UUID de la analítica a obtener
 */
  uuidAnalitica: string;
}

export function analiticasControllerObtenerAnalitica(http: HttpClient, rootUrl: string, params: AnaliticasControllerObtenerAnalitica$Params, context?: HttpContext): Observable<StrictHttpResponse<ObtenerAnaliticaModelDto>> {
  const rb = new RequestBuilder(rootUrl, analiticasControllerObtenerAnalitica.PATH, 'get');
  if (params) {
    rb.path('uuidAnalitica', params.uuidAnalitica, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObtenerAnaliticaModelDto>;
    })
  );
}

analiticasControllerObtenerAnalitica.PATH = '/api/paciente-analiticas/obtener-analitica/{uuidAnalitica}';
